export const imageBaseApi = "https://api-app-kangaroo.danfesolution.com";
